import { render, staticRenderFns } from "./market.vue?vue&type=template&id=4cf99e6c&"
import script from "./market.vue?vue&type=script&lang=ts&"
export * from "./market.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports